import React from 'react';

const numberedData = [
  {
    number: 1,
    title: "Erat at semper",
    description: "Non amet fermentum est in enim at sit ullamcorper. Sit elementum rhoncus nullam feugiat. Risus sem fermentum...",
  },
  {
    number: 2,
    title: "Urna nec vivamus risus duis arcu",
    description: "Aliquam adipiscing velit semper morbi. Purus non eu cursus porttitor tristique et gravida. Quis nunc interdum gravida ullamcorper",
  },
  {
    number: 3,
    title: "Lobortis euismod imperdiet tempus",
    description: "Viverra scelerisque mauris et nullam molestie et. Augue adipiscing praesent nisl cras nunc luctus viverra nisi",
  },
  {
    number: 4,
    title: "Cras nulla aliquet nam eleifend amet et",
    description: "Aliquam adipiscing velit semper morbi. Purus non eu cursus porttitor tristique et gravida. Quis nunc interdum gravida ullamcorper sed integer. Quisque eleifend tincidunt vulputate libero",
  },
];

const NumberedItem = ({ number, title, description }) => (
  <div className="flex items-start space-x-4">
    <div className="flex-shrink-0 w-8 h-8 rounded-full bg-slate-900 text-white flex items-center justify-center font-bold">
      {number}
    </div>
    <div>
      <h3 className="font-bold text-lg text-slate-900 mb-1">{title}</h3>
      <p className="text-slate-500 text-sm">{description}</p>
    </div>
  </div>
);

const NumberedSection = () => {
  return (
    <section className="bg-slate-950 py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        {/* Replaced Image Placeholder with the actual image */}
        <div className="rounded-lg h-96 overflow-hidden">
          <img 
            src="/assets/about.jpg" 
            alt="About us" 
            className="w-full h-full object-cover" 
          />
        </div>

        {/* Numbered list on the right */}
        <div className="space-y-8">
          {numberedData.map((item) => (
            <NumberedItem 
              key={item.number} 
              number={item.number} 
              title={item.title} 
              description={item.description} 
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default NumberedSection;